import getServiceName from '../getServiceName';
import { AxiosResponse, AxiosRequestConfig, AxiosError } from '../Axios';

interface Throttle {
  promise: Promise<void>;
  complete: boolean;
  resolve: () => void;
  timerId: number;
}
const maxThrottleDelay = 30000; // 30 seconds.
const throttles: Record<string, Throttle> = {};

const resolveThrottle = (serviceName: string | null) => {
  if (!serviceName) {
    return;
  }

  const throttle = throttles[serviceName];
  if (!throttle || throttle.complete) {
    return;
  }

  throttle.complete = true;
  clearTimeout(throttle.timerId);
  throttle.resolve();
};

export const throttleGate = (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const serviceName = getServiceName(config);
  if (!serviceName) {
    return Promise.resolve(config);
  }

  if (config.disableNovaServiceThrottle) {
    return Promise.resolve(config);
  }

  if (throttles[serviceName]) {
    return throttles[serviceName].promise.then(() => config);
  }

  let resolve: () => void;
  const promise = new Promise<void>((res) => {
    resolve = res;
  });
  throttles[serviceName] = {
    promise,
    complete: false,
    resolve: resolve!,
    timerId: window.setTimeout(() => {
      resolveThrottle(serviceName);
    }, maxThrottleDelay),
  };

  return Promise.resolve(config);
};

export const throttleRelease = (result: AxiosResponse<any>) => {
  resolveThrottle(getServiceName(result.config));
  return result;
};

export const throttleReleaseError = (error: AxiosError) => {
  resolveThrottle(getServiceName(error.config));
  return Promise.reject(error);
};
